import React from "react";

const StudentCorner = () => {
  return (
    <div>
      <h1>Welcome to the Student Corner</h1>
      <p>This is a placeholder for student-specific content.</p>
      <p>Here you can find resources, submit issues, notes, and leave letters.</p>
    </div>
  );
}

export default StudentCorner;